import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const createDoctor = async (data) => {
    const { name, clinicName, email, phone, website, address } = data;
    try {
        const res = await axiosPrivate.post('doctor/create', {
            name: name,
            clinicName: clinicName,
            email: email,
            phone: phone,
            website: website,
            address: address
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const getAllDoctors = async () => {
    try {
        const res = await axiosPrivate.get('doctors/all');
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}